<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="title" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="name"
            name="title"
            placeholder="title"
            rules="required"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
      <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="optional"
            label="Description"
            name="description"
            placeholder="description"
            rules=""></dg-text-field>
      </el-col>
    </el-row>
    <el-row>
      <h6 class="border-bottom mt-5 mb-3 font-weight-bold pb-2">Package Features</h6>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            dataParent="features"
            dataParentType="object"
            dataNameInParent="testingPanelFeature"
            :defaultValue="testingPanelFeature"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark=""
            label="Testing Panel Feature"
            name="testingPanelFeature"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              <b>Give the ability to use: </b><br>
              Testing Panel Feature and its division <br>
              History of previews tests <br>
              Take action for tests
            </div>
          </template>
        </dg-switch>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            dataParent="features"
            dataParentType="object"
            dataNameInParent="vendorsRatesFeature"
            :defaultValue="vendorsRatesFeature"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark=""
            label="Vendors & Rates"
            name="vendorsRatesFeature"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              <b>Give the ability to</b><br>
              Create vendors<br>
              Upload Rates document<br>
              View, Create and delete Rates<br>
              View and uploaded documents
            </div>
          </template>
        </dg-switch>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            dataParent="features"
            dataParentType="object"
            dataNameInParent="destinationStatusFeature"
            :defaultValue="destinationStatusFeature"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark=""
            label="Destination Status"
            name="destinationStatusFeature"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              <b>Give the ability to</b><br>
              View current status of destinations<br>
            </div>
          </template>
        </dg-switch>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            dataParent="features"
            dataParentType="object"
            dataNameInParent="lcrFeature"
            :defaultValue="lcrFeature"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark=""
            label="LCR"
            name="lcrFeature"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              <b>Give the ability to</b><br>
              Use LCR Table<br>
            </div>
          </template>
        </dg-switch>
      </el-col>


      <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">

        <dg-label-field :translate="false"  label="Testing Panel"></dg-label-field>
        <el-switch v-model="dataModel.testingPanelFeature"></el-switch>


        <dg-label-field :translate="false" class="ml-5" label="Vendors Setting"></dg-label-field>
        <el-switch v-model="dataModel.vendorsSettingFeature"></el-switch>

        <dg-label-field :translate="false" class="ml-5" label="Destinations Status"></dg-label-field>
        <el-switch v-model="dataModel.destinationsStatusFeatures"></el-switch>

        <dg-label-field :translate="false" class="ml-5" label="LCR"></dg-label-field>
        <el-switch v-model="dataModel.lcrFeature" disabled></el-switch>
        &lt;!&ndash;<div v-if="dataModel.usingPrivateRate" class="mt-2 ml-2">
          <small class="text-secondary font-italic">Customer Private Rate Document Should have  Working Destinations File fields with edited rates.</small>
          <dg-file-upload
              :allowed-ext="['xlsx','xls']"
              :control="control"
              :field_span="24"
              :file-size-limit="12"
              :label_span="24"
              field_mark="required"
              label="rates_document"
              name="rate_document"
              rules="required"></dg-file-upload>
        </div>&ndash;&gt;
      </el-col>-->
    </el-row>

    <el-row>
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{ (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria') }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="moduleDeleteAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                     :translate="false"
                     :type="actionButtonType" fieldSize="mini"
                     v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  beforeMount() {this.getFormData()},
  data() {
    return {
      testingPanelFeature: false,
      destinationStatusFeature: false,
      vendorsRatesFeature: false,
      lcrFeature: false,
      module: {...module},
      dataModel: {
        features: {}
      },
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
    }
  },
  methods: {
    getFormData() {
      let promises = []
      promises.push(this.getEntityDropDownList().then())
      Promise.all(promises).then((values) => {
        if (this.dataToBind) {

          let features = this.dataToBind.features
          for (let f in features) {
            this.dataToBind[features[f].module_name] = 1
            this.dataModel.features[features[f].module_name] = true
          }

          let switches = [
              'testingPanelFeature',
              'vendorsRatesFeature',
              'destinationStatusFeature',
              'lcrFeature'
          ]

          for (let s in switches) {
            let val = switches[s]
            this.dataToBind[val] = (this.dataToBind[val] == 1 || this.dataToBind[val])? true : false
          }
        }
        this.amReady = true
        $vue.nextTick(() => {this.bindController()})
      })
    },
    ...$mapActions('subscription-features-package-api', {
      getEntityDropDownList: 'getDropDownList',
      updateImage: 'updateImage',
      updateGallery: 'updateGallery',
      removeGalleryImage: 'removeGalleryImage'
    }),
    async createModule() {
      this.validateFields().then( async result => {
        if (!result) { this.requestErrorMessage = null; return}

        this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;

        this.$store.dispatch('subscription-features-package-api/' + apiMethod, apiParams).then(response => {
          let entity = response.data
          this.amReady = false
          notifySuccess((apiMethod == 'update')? 'Updated' : 'Created')


          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          console.log('catch error', error)
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {this.requestOn = false})
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
